import { useEffect } from 'react';

import { refreshGPTAds, showGPTAds } from '@helpers/ads';

export function useGPTAdsRefresh(googleSlots?: Array<googletag.Slot>) {
  useEffect(() => {
    if (!googleSlots || googleSlots.length === 0) return;

    googleSlots.map((slot) => showGPTAds(slot));
    refreshGPTAds(googleSlots);
  }, [googleSlots]);
}
